module.exports = __webpack_public_path__ + "static/img/expend.001f83.png";